import { eventNameId } from '../fixture-ids';

export const eventNameEntries = {
  EVENT_NAME_CREATED: {
    entity: 'eventName',
    identity: 'record',
    idKeys: ['id'],
    renderMode: 'diff',
    createsRecord: true,
  },
  // The current writer emits 'id'; legacy rows carry 'eventNameId' for the same table. The legacy
  // alternate declares that alias, so the composed entry resolves either.
  EVENT_NAME_UPDATED: {
    entity: 'eventName',
    identity: 'record',
    idKeys: ['id'],
    renderMode: 'diff',
    createsRecord: false,
  },
  // Same legacy id-key difference as EVENT_NAME_UPDATED.
  EVENT_NAME_DELETED: {
    entity: 'eventName',
    identity: 'record',
    idKeys: ['id'],
    renderMode: 'diff',
    createsRecord: false,
  },
};

export const eventNameFixtures = {
  EVENT_NAME_CREATED: {
    action: 'EVENT_NAME_CREATED',
    debugData: { id: eventNameId, name: 'checkout_completed', description: 'Fires when checkout completes' },
  },
  EVENT_NAME_UPDATED: {
    action: 'EVENT_NAME_UPDATED',
    debugData: {
      id: eventNameId,
      name: 'checkout_completed',
      description: 'Fires when a checkout completes successfully',
    },
  },
  EVENT_NAME_DELETED: {
    action: 'EVENT_NAME_DELETED',
    debugData: {
      id: eventNameId,
      name: 'checkout_completed',
      description: 'Fires when a checkout completes successfully',
    },
  },
};
